// extracted by mini-css-extract-plugin
export default {"quoteButton":"GetAQuoteButton_quoteButton__JWI-h"};